import _jsx from "@babel/runtime/helpers/jsx";
var _div, _div2;
import React from 'react';

/**
 *  The InventoryListingPlaceholder is used to preserve space for anticipated listing elements that maybe loaded
 *  after initial render has completed.
 */
function InventoryListingPlaceholder(_ref, ref) {
  let {
    orientation = 'portrait',
    ...rest
  } = _ref;
  if (orientation === 'landscape') {
    return /*#__PURE__*/React.createElement("div", Object.assign({
      "data-cmp": "inventoryListingPlaceholder",
      ref: ref
    }, rest), /*#__PURE__*/_jsx("div", {
      className: "inventory-listing cursor-pointer display-flex flex-column panel panel-default"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "item-card display-flex skeleton__listing skeleton__loading"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "padding-0 margin-bottom-3 margin-bottom-sm-0"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "skeleton__image skeleton__placeholder",
      style: {
        height: '200px',
        width: '266px'
      }
    })), _div || (_div = /*#__PURE__*/_jsx("div", {
      className: "col-sm-8 col-md-8 col-lg-9 padding-horizontal-4 padding-top-3"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "row"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "col-xs-7 col-sm-5"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "skeleton__headline skeleton__placeholder"
    })), /*#__PURE__*/_jsx("div", {
      className: "col-xs-3 col-sm-2 col-xs-offset-2 col-sm-offset-5"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "skeleton__text skeleton__placeholder"
    }))), /*#__PURE__*/_jsx("div", {
      className: "row"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "col-xs-7 col-sm-5"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "skeleton__text skeleton__placeholder"
    })), /*#__PURE__*/_jsx("div", {
      className: "col-xs-3 col-sm-2 col-xs-offset-2 col-sm-offset-5"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "skeleton__text skeleton__placeholder"
    }))), /*#__PURE__*/_jsx("div", {
      className: "row"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "col-xs-5 col-sm-3"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "skeleton__headline skeleton__placeholder"
    })), /*#__PURE__*/_jsx("div", {
      className: "col-xs-2 col-sm-1 col-xs-offset-5 col-sm-offset-8"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "skeleton__text skeleton__placeholder"
    }))), /*#__PURE__*/_jsx("div", {
      className: "row"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "col-xs-12"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "skeleton__spacer"
    }))), /*#__PURE__*/_jsx("div", {
      className: "row"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "col-xs-10 col-md-5"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "skeleton__text skeleton__placeholder"
    })), /*#__PURE__*/_jsx("div", {
      className: "col-xs-8 col-md-3 col-lg-4"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "skeleton__text skeleton__placeholder"
    })), /*#__PURE__*/_jsx("div", {
      className: "col-xs-2 col-lg-1"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "skeleton__text skeleton__placeholder"
    })), /*#__PURE__*/_jsx("div", {
      className: "col-xs-2 col-lg-1"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "skeleton__text skeleton__placeholder"
    }))))))));
  }
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "inventoryListingPlaceholder",
    ref: ref
  }, rest), _div2 || (_div2 = /*#__PURE__*/_jsx("div", {
    className: "inventory-listing cursor-pointer display-flex flex-column panel panel-default"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "row item-card skeleton__listing skeleton__loading skeleton__fixedheight"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-12 padding-0"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "skeleton__image_portrait skeleton__placeholder"
  })), /*#__PURE__*/_jsx("div", {
    className: "col-xs-12 padding-4"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-12"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "skeleton__headline skeleton__placeholder"
  }))), /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-6"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "skeleton__subtext skeleton__placeholder"
  }))), /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-11 margin-bottom-1 margin-bottom-sm-2 margin-bottom-lg-1"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "skeleton__subtext skeleton__placeholder"
  }))), /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-4 margin-bottom-2"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "skeleton__subtext skeleton__placeholder"
  }))), /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-8"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "skeleton__headline skeleton__placeholder"
  }))), /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-7 margin-bottom-3 margin-bottom-sm-6 margin-bottom-lg-3"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "skeleton__text skeleton__placeholder"
  }))), /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-10"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "skeleton__subtext skeleton__placeholder"
  }))), /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-4"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "skeleton__subtext skeleton__placeholder"
  })), /*#__PURE__*/_jsx("div", {
    className: "col-xs-4"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "skeleton__subtext skeleton__placeholder"
  }))), /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-4"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "skeleton__subtext skeleton__placeholder"
  }))))))));
}
export default /*#__PURE__*/React.forwardRef(InventoryListingPlaceholder);